import React from 'react';
import _ from 'lodash';
import moment from 'moment'
import cookies from "../cookies"
import printJS from 'print-js'

export default class Master extends React.Component {

    state = {
        dialogOpen: false,
        newEntry: {},
        singleEntry: {},
        tableFilter: {},
        putLoading: false,
        newEntryKey: "newEntry",
        uploadFiles: [],
        previewImages: [],
        filter: {},
        copyData: []
    }

    componentWillMount() {
        var filter = cookies.get(window.location.pathname+"_filter")
        if(filter) {
            this.state.filter = filter
        }
    }

    openTab = (uri, print) => {
        if(print !== undefined) {
            printJS({printable:uri, type:'pdf', showModal:true})
            return
        }
        var win = window.open("/" + uri, '_blank');
        win.focus()
    }

    setCookie(key, value) {
        cookies.set(key, value)
    }

    getCookie(key) {
        return cookies.get(key)
    }

    componentWillUnmount() {
        if(this.unsubscribe !== undefined) {
            this.unsubscribe()
        }
    }

    toggleDisabled = () => {
        this.setState({
            disabled: !this.state.disabled
        })
    }

    handleClickOpen = (doReset, key) => {
        var doKey = "dialogOpen"
        if(key !== undefined) {
            doKey = key
        }
        if(doReset) {
            this.state.newEntry = {}
        }
        this.setState({
            [doKey]: !this.state[doKey]
        });
    }

    handleChangeUser = (name, user) => {
        var key = this.state.newEntryKey
        if(key === undefined) {
            key = "newEntry"
            if(this.state.newEntryKey === undefined) {
                key = "newEntry"
            }
        }
        this.state[key][name] = user
        this.setState({
            [key]: this.state[key]
        });
    }

    handleChange = (name, uppercase, key, subKey) => event => {

        if(event === null || event === undefined) return

        var value = ""
        if (event._d !== undefined) {
            value = event._d
        } else if (event.target === undefined) {
            value = event
        } else {
            value = event.target.value
            if(event.target.type === "checkbox") {
                value= event.target.checked
            }
            if(event.target.type === "number") {
                var val = ("" + event.target.value).replace(",", ".")
                console.log("val", val)
                value = parseFloat(val)
            }
        }

        if(key === undefined) {
            key = this.state.newEntryKey
            if(this.state.newEntryKey === undefined) {
                key = "newEntry"
            }
        }
        if(uppercase) {
            value = value.toUpperCase()
        }
        if(subKey !== undefined) {
            if(this.state[key][subKey] === undefined) {
                this.state[key][subKey] = {}
            }
            this.state[key][subKey][name] = value
            this.setState({
                [key]: this.state[key]
            });
        } else {
            if(this.state[key] === undefined) {
                this.state[key] = {}
            }
            this.state[key][name] = value
            this.setState({
                [key]: this.state[key]
            });
        }
        
    }

    handleChangeSelect = (name, key) => event => {
        if(key === undefined) {
            key = this.state.newEntryKey
            if(this.state.newEntryKey === undefined) {
                key = "newEntry"
            }
        }
        this.setState({
            [key]: {
                ...this.state[key],
                [name]: {
                    value: event.value,
                    label: event.name,
                    id: event.value,
                    ...event,
                },
                [name + "_id"]: event.value
            }
        })
    }

    _postData = () => {
        this.postData()
    }

    postData = () => {
        if(this.props.doPost === undefined) {
            this.setState({
                dialogOpen: false
            })
            console.error("no doPost defined")
            return
        }
        this.props.doPost(this.state.newEntry)
        this.setState({
            newEntry: {}
        })
    }

    saveData = () => {
        var key = this.state.newEntryKey
        if(key === undefined) {
            key = "newEntry"
            if(this.state.newEntryKey === undefined) {
                key = "newEntry"
            }
        }

        var entry = this.state[key]
        var id = entry.id

        var uploadFiles = this.state.uploadFiles
        var previewImages = this.state.previewImages
        if(uploadFiles && uploadFiles[id] !== undefined && uploadFiles[id].length > 0) {
            var i = 0
            Object.keys(uploadFiles[id]).forEach((key) => {
                var neuerBildEintrag = {
                    name: uploadFiles[id][key].name,
                    size: uploadFiles[id][key].size,
                    type: uploadFiles[id][key].type,
                    image: previewImages[id][key],
                    position: i,
                }
                if(entry.bilder === undefined) {
                    entry.bilder = []
                }
                entry.bilder.push(neuerBildEintrag)
                i++
            })
            uploadFiles[id] = []
            previewImages[id] = []
            console.log("uploadFiles", uploadFiles, previewImages)
            this.setState({
                uploadFiles: uploadFiles,
                previewImages: previewImages,
            })
        }

        this.props.doPut(this.state[key].id, entry)

        if(this.state.disabled !== undefined) {
            this.setState({disabled: true})
        }
        
    }

    filter = (key, value) => {
        if(key === "reset") {
            this.state.filter = {}
        } else {
            if(this.state.filter && this.state.filter[key] && this.state.filter[key] === value) {
                delete this.state.filter[key]
            } else {
                if(this.state.filter === undefined) {
                    this.state.filter = {}
                }
                this.state.filter[key] = value 
            }
        }
        cookies.set(window.location.pathname+"_filter", this.state.filter)
        this.props.doLoad(this.state.filter)
    }

    populate = (data) => {
        this.props.doLoad({...data, ...this.state.filter})
    }

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    gotoToDetail = (rowIndex, data) => {
        var id = ""
        if(data[data.length-1].value !== undefined) {
            id = data[data.length-1].value
        } else {
            id = data[data.length-1]
        }
        this.props.history.push(this.state.route+"/"+id)
    }

    gotoTo = (href, _blank) => {
        if(_blank) {
            window.open(href, "_blank");
            return
        }
        this.props.history.push(href)
    }

    handleChangePanel = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    }

    appendImages = itemId => event => {

        Object.keys(event.target.files).forEach((key) => {

            let reader = new FileReader();
            let file = event.target.files[key];

            reader.onloadend = () => {
                if(this.state.previewImages[itemId] === undefined) {
                    this.state.previewImages[itemId] = []
                }
                this.state.previewImages[itemId][key] = reader.result
                this.setState({
                    previewImages: this.state.previewImages
                })
            }

            reader.readAsDataURL(file)

        })

        var uploadFiles = this.state.uploadFiles
        if(uploadFiles[itemId] === undefined) {
            uploadFiles[itemId] = []
        }
        uploadFiles[itemId] = event.target.files

        this.setState({
            uploadFiles: uploadFiles
        })

    }

    removeFile = (id, removeKey) => {
        var uploadFiles = this.state.uploadFiles
        var previewImages = this.state.previewImages

        if(uploadFiles[id] === undefined) {
            return
        }

        var files = []
        Object.keys(uploadFiles[id]).forEach((key) => {
            if (key !== removeKey) {
                files.push(uploadFiles[id][key])
            }
        })
        uploadFiles[id] = files

        delete previewImages[id][removeKey]
        previewImages[id] = previewImages[id].filter(function(item) {
            return item !== undefined
        })

        this.setState({
            previewImages: previewImages,
            uploadFiles: uploadFiles
        })
    }

    removeImage = (id, itemKey, removeKey) => {

        var key = this.state.newEntryKey
        if(key === undefined) {
            key = "newEntry"
            if(this.state.newEntryKey === undefined) {
                key = "newEntry"
            }
        }

        var entry = this.state[key]

        entry.bilder.forEach((item, key) => {

            if(removeKey === key) {
                var image = entry.bilder[removeKey]
                this.props.bild_doDelete(item.id, {parent: entry.id, position: image.position, name: image.name})
                this.removeFile(key, removeKey)
                delete entry.bilder[removeKey]
            }

            entry.bilder = entry.bilder.filter(function(item) {
                return item !== undefined
            })

        })

        this.setState({
            [key]: entry
        })

    }

    search = name => event => {
        if(name !== undefined) {
            this.props[name + "_doSearch"]({s: event.target.value})
            return
        }
        this.props.doSearch({s: event.target.value})
        this.state.searchValue = event.target.value
    }

    searchRaw = event => {
        this.props.doSearch({s: event.target.value})
        this.state.searchValue = event.target.value
    }

    onInputChange = name => event => {
        if(name !== undefined) {
            this.props[name + "_doSearch"]({s: event})
            return
        }
        this.props.doSearch({s: event})
    }

    handleChangeColor = (color) => {
        this.state.newEntry.farbe = color.hex
        this.setState({
            newEntry: this.state.newEntry
        })
    }

    intToTime = (value) => {
        value = ""+value
        var val = ""+parseInt(value.replace(":", ""))
        if(isNaN(val)) {
            return ""
        }
        if(parseInt(value) < 10) {
            return "00:0"+val
        }
        if(parseInt(value) < 100) {
            return "00:"+val
        }
        if(parseInt(value) < 1000) {
           return "0"+val[0]+":"+val[1]+val[2]
        }
        var valExp = parseInt(val[0] + val[1])
        if(valExp >= 24) {
            var diff = 24 - valExp
        }
        return val[0] + val[1] + ":" + val[2] + val[3]
    }

    convertStringToIntHours = value => {
        var valueString = (""+parseInt(value)).replace(":", "")

        var hours = 0
        var minutes = 0

        if(valueString.length <= 4) {
            if(valueString.length < 4) {
                while (valueString.length < 4) {
                    valueString = "0" + valueString
                }
            }
            hours   = parseInt(valueString[0] + valueString[1])
            minutes = parseInt(valueString[2] + valueString[3])
        }

        if(valueString.length > 4) {
            var hourString = ""
            for(var i = 0;i < valueString.length-2;i++) {
                hourString += valueString[i]
            }
            hours = parseInt(hourString)
            minutes = parseInt(valueString[valueString.length-2] + valueString[valueString.length-1])
        }

        return hours * 60 + minutes
    }

    lock = () => {
        if(!this.state.newEntry.lock && window.confirm("Soll der Fahrplan gesperrt werden?")) {
            this.state.newEntry.lock = true
            this.saveAction()
            return
        }
        if(this.state.newEntry.lock && window.confirm("Soll der Fahrplan entsperrt werden?")) {
            this.state.newEntry.lock = false
            this.saveAction()
        }
    }

    getCellClipboardData = (rowIndex, columnIndex) => {
        console.log("rowIndex", rowIndex)
        if(!this.state.copyData[rowIndex]) {
            return ""
        }
        if(!this.state.copyData[rowIndex][columnIndex]) {
            return ""
        }
        if(parseInt(this.state.copyData[rowIndex][columnIndex])>0) {
            return (this.state.copyData[rowIndex][columnIndex]+"").replace(".", ",")
        }
        return this.state.copyData[rowIndex][columnIndex]
    }

}



// WEBPACK FOOTER //
// ./src/Components/Master.js